import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AppLoaderComponent } from './app-loader.component';

@Injectable()
export class AppLoaderService {
  dialogRef: MatDialogRef<AppLoaderComponent>;
  constructor(private dialog: MatDialog) { }

  public open(title: string = 'Por favor aguarde.', animation = true): Observable<boolean> {
    this.dialogRef = this.dialog.open(AppLoaderComponent, {
      disableClose: true
    });
    this.dialogRef.updateSize('auto');
    this.dialogRef.componentInstance.title = title;
    this.dialogRef.componentInstance.animation = animation;
    return this.dialogRef.afterClosed();
  }

  public close() {
    // tslint:disable-next-line:curly
    if (this.dialogRef) this.dialogRef.close();
  }

  public openOnlyMessage(title: string = 'Por favor aguarde.'): Observable<boolean> {
    this.dialogRef = this.dialog.open(AppLoaderComponent, {
      disableClose: true
    });
    this.dialogRef.updateSize('auto');
    this.dialogRef.componentInstance.title = title;
    this.dialogRef.componentInstance.animation = false;

    setTimeout(() => {
      this.close();
    }, 5000);

    return this.dialogRef.afterClosed();
  }

}
